module.exports = __webpack_public_path__ + "static/media/icons.dbc1ef8b.eot";